module.exports = __webpack_public_path__ + "img/add_row_before.415f0d43.svg";